/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Trial_TitleInputs */

const en_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Mode`)
};

const fr_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode d'essai`)
};

const de_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testmodus`)
};

const it_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di prova`)
};

const ru_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробный режим`)
};

const es_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de prueba`)
};

const zh_cn2_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用模式`)
};

const ja_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルモード`)
};

const hi_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण मोड़`)
};

const pt_pt2_ccsl_export_trial_title = /** @type {(inputs: Ccsl_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de teste`)
};

/**
* | output |
* | --- |
* | "Trial Mode" |
*
* @param {Ccsl_Export_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_trial_title = /** @type {((inputs?: Ccsl_Export_Trial_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Trial_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_trial_title(inputs)
	if (locale === "de") return de_ccsl_export_trial_title(inputs)
	if (locale === "it") return it_ccsl_export_trial_title(inputs)
	if (locale === "ru") return ru_ccsl_export_trial_title(inputs)
	if (locale === "es") return es_ccsl_export_trial_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_trial_title(inputs)
	if (locale === "ja") return ja_ccsl_export_trial_title(inputs)
	if (locale === "hi") return hi_ccsl_export_trial_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_trial_title(inputs)
	return en_ccsl_export_trial_title(inputs)
});